angular.module('pitch.app')
.factory('Locale', function(config, $rootScope, satvStorage) {
    'use strict';

    return {
        set: function(v) {
            satvStorage.set('LOCALE', v);
        },
        get: function() {
            return satvStorage.get('LOCALE') || config.defaultLang;
        }
    };
})

.run(function($rootScope, Locale) {
    //store the latest locale each time it is part of a state
    $rootScope.$on('$stateChangeStart', function(from, to, stateParams) {
        if (stateParams.lang) {
            Locale.set(stateParams.lang);
        }
    });
})

/**
 * Interceptor to replace :lang with lang contained in rootscrope.
 * NOTE: This is mainly used for template paths
 */
.factory('LocaleParamReplacementInterceptor',
    function (config, Locale) {
        "use strict";
        return {
            request: function(requestConfig) {
                requestConfig.url = requestConfig.url.replace(':lang', Locale.get());
                return requestConfig;
            }
        };
    }
)

.config(function($httpProvider) {
    $httpProvider.interceptors.push('LocaleParamReplacementInterceptor');
})

;




// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/Locale.js